import { AmountFrequency } from "Infrastructure/ApiZfp/Schema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { type ResourcePathType, Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";

export const getYearsInflected = (years: number) => {
  if (years === 1) {
    return Resources.Common.Year;
  }

  if (years > 1 && years <= 4) {
    return Resources.Common.YearsFew;
  }

  return Resources.Common.Years;
};

export const getAmountFrequencyTranslation = (
  frequency: AmountFrequency,
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => {
  switch (frequency) {
    case AmountFrequency.yearly:
      return t(Resources.Common.Year);
    case AmountFrequency.half_yearly:
      return t(Resources.Common.HalfYear);
    case AmountFrequency.quarterly:
      return t(Resources.Common.QuarterYear);
    case AmountFrequency.monthly:
      return t(Resources.Common.Month);
    case AmountFrequency.one_time:
      return t(Resources.Common.OneTime);
  }
};

export const getCzechPluralForm = <T>(count: number, forms: { one: T; few: T; other: T }): T => {
  if (count === 1) return forms.one;
  if (count >= 2 && count <= 4) return forms.few;
  return forms.other;
};

export const formatFamilyMembersCount = (count: number, t: (resourcePath: ResourcePathType, options?: any) => string) =>
  t(
    getCzechPluralForm(count, {
      one: Resources.Common.FamilyMembers_one,
      few: Resources.Common.FamilyMembers_few,
      other: Resources.Common.FamilyMembers_other,
    }),
    { count },
  );

export const formatItemsCount = (count: number, t: (resourcePath: ResourcePathType, options?: any) => string) =>
  t(
    getCzechPluralForm(count, {
      one: Resources.Common.Items_one,
      few: Resources.Common.Items_few,
      other: Resources.Common.Items_other,
    }),
    { count },
  );

export const inflectYears = (year: number, t: (resourcePath: ResourcePathType, options?: any) => string) => {
  if (year === 1) {
    return `${year} ${t(Resources.Common.Year)}`;
  }

  if (year <= 4 && year !== 0) {
    return `${year} ${t(Resources.Common.YearsFew)}`;
  }

  return `${year} ${t(Resources.Common.Years)}`;
};

export const inflectMonths = (count: number, t: (resourcePath: ResourcePathType, options?: any) => string) => {
  if (count === 1) {
    return `${t(Resources.Common.Months_one, { count })}`;
  }

  if (count <= 4 && count !== 0) {
    return `${t(Resources.Common.Months_few, { count })}`;
  }

  return `${t(Resources.Common.Months, { count })}`;
};

export const inflectChildren = (count: number, t: (resourcePath: ResourcePathType, options?: any) => string) => {
  if (count === 1) {
    return `${t(Resources.Common.Child)}`;
  }

  if (count < 4 && count !== 0) {
    return `${t(Resources.Common.Children)}`;
  }

  return `${t(Resources.Common.ChildrenMany)}`;
};
